import { Translator } from 'Translator';
import { SubOption } from 'model/Filters';

const subCategoriesSubOptions = [
  {
    id: 13,
    name: Translator.translate(
      'UserEnvironment.Filters.homeDinners',
      {},
      true,
      'Home dinners',
    ),
    value: 'home-dinners',
  },
  {
    id: 14,
    name: Translator.translate(
      'UserEnvironment.Filters.foodToursAndTastings',
      {},
      true,
      'Food tours and tastings',
    ),
    value: 'food-tours-tastings',
  },
  {
    id: 914,
    name: Translator.translate(
      'UserEnvironment.Filters.foodTours',
      {},
      true,
      'Food tours',
    ),
    value: 'food-tours',
  },
  {
    id: 915,
    name: Translator.translate(
      'UserEnvironment.Filters.cityTours',
      {},
      true,
      'City highlights tours',
    ),
    queryValue: 'city-highlight-tours',
    value: 'city-tours',
  },
  {
    id: 916,
    name: Translator.translate(
      'UserEnvironment.Filters.offTheBeatenTrack',
      {},
      true,
      'Off the beaten track tours',
    ),
    value: 'off-the-beaten-track',
  },
  {
    id: 917,
    name: Translator.translate(
      'UserEnvironment.Filters.nightTours',
      {},
      true,
      'Night tours',
    ),
    value: 'night-tours',
  },
  {
    id: 918,
    name: Translator.translate(
      'UserEnvironment.Filters.skipTheLineTours',
      {},
      true,
      'Skip the line tours',
    ),
    value: 'skip-the-line-tours',
  },
  {
    id: 919,
    name: Translator.translate(
      'UserEnvironment.Filters.dayTrips',
      {},
      true,
      'Day trips',
    ),
    value: 'day-trips',
  },
  {
    id: 920,
    name: Translator.translate(
      'UserEnvironment.Filters.multiDayTrips',
      {},
      true,
      'Multi day trips',
    ),
    value: 'multi-day-trips',
  },
  {
    id: 921,
    name: Translator.translate(
      'UserEnvironment.Filters.shoppingTours',
      {},
      true,
      'Shopping tours',
    ),
    value: 'shopping-tours',
  },
  {
    id: 922,
    name: Translator.translate(
      'UserEnvironment.Filters.artCultureTours',
      {},
      true,
      'Art & Culture Tours',
    ),
    value: 'art-culture-tours',
  },
  {
    id: 923,
    name: Translator.translate(
      'UserEnvironment.Filters.wineBeerTours',
      {},
      true,
      'Wine & Beer tours',
    ),
    value: 'wine-beer-tours',
  },
  {
    id: 924,
    name: Translator.translate(
      'UserEnvironment.Filters.cookingClasses',
      {},
      true,
      'Cooking classes',
    ),
    value: 'cooking-classes',
  },
  {
    id: 925,
    name: Translator.translate(
      'UserEnvironment.Filters.tastings',
      {},
      true,
      'Food & drink tastings',
    ),
    value: 'tastings',
  },
  {
    id: 926,
    name: Translator.translate(
      'UserEnvironment.Filters.wildlifeNature',
      {},
      true,
      'Wildlife & Nature',
    ),
    value: 'wildlife-nature',
  },
  {
    id: 927,
    name: Translator.translate(
      'UserEnvironment.Filters.workshops',
      {},
      true,
      'Workshops',
    ),
    value: 'workshops',
  },
  {
    id: 928,
    name: Translator.translate(
      'UserEnvironment.Filters.sportsLeisure',
      {},
      true,
      'Sports & Leisure',
    ),
    value: 'sports-leisure',
  },
  {
    id: 929,
    name: Translator.translate(
      'UserEnvironment.Filters.other',
      {},
      true,
      'Other',
    ),
    value: 'other',
  },
  {
    id: 930,
    name: Translator.translate(
      'UserEnvironment.Filters.photoTours',
      {},
      true,
      'Photo tours',
    ),
    value: 'photo-tours',
  },
  {
    id: 913,
    name: Translator.translate(
      'UserEnvironment.Filters.foodDrinkTastings',
      {},
      true,
      'Food & Drink tastings',
    ),
    value: 'food-drink-tastings',
  },
] as SubOption[];

export default subCategoriesSubOptions;
